// // Sidebar.js
// import React from "react";
// import Profile from "./Profile";
// import { Link } from "react-router-dom";

// const Sidebar = () => {
//   const { role, profileData, isAuthenticated } = Profile();

//   const sidebarItems = {
//     admin: [
//       {
//         title: "Dashboard",
//         icon: "mdi mdi-view-dashboard",
//         link: "/dashboard",
//       },
//       { title: "Email", icon: "mdi mdi-email", link: "/email" },
//       { title: "Users", icon: "mdi mdi-worker", link: "/users" },
//       { title: "Profile", icon: "mdi mdi-face", link: "/my-profile" },
//     ],
//     employee: [
//       // { title: "Dashboard", icon: "mdi mdi-view-dashboard", link: "/dashboard" },
//       { title: "Email", icon: "mdi mdi-email", link: "/email" },
//       { title: "Profile", icon: "mdi mdi-face", link: "/my-profile" },
//     ],
//   };

//   return (
//     <nav className="sidebar sidebar-offcanvas" id="sidebar">
//       <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
//         <a className="sidebar-brand brand-logo" href="/">
//           <h4>Email Sender</h4>
//         </a>
//       </div>
//       <ul className="nav">
//         {isAuthenticated && (
//           <li className="nav-item profile">
//             <div className="profile-desc">
//               <div className="profile-pic">
//                 <img
//                   className="img-xs rounded-circle"
//                   src="/assets/images/faces/face15.jpg"
//                   alt=""
//                 />
//                 <div className="profile-name">
//                   <h5 className="mb-0 font-weight-normal">
//                     {profileData.name}
//                   </h5>
//                   <span>{profileData.email}</span>
//                 </div>
//               </div>
//             </div>
//           </li>
//         )}
//         {sidebarItems[role]?.map((item) => (
//           <li className="nav-item menu-items" key={item.title}>
//             <Link className="nav-link" to={item.link}>
//               <span className="menu-icon">
//                 <i className={item.icon}></i>
//               </span>
//               <span className="menu-title">{item.title}</span>
//             </Link>
//           </li>
//         ))}
//       </ul>
//     </nav>
//   );
// };

// export default Sidebar;

// Sidebar.js
import React from "react";
import Profile from "./Profile";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const { role, profileData, isAuthenticated } = Profile();
  const location = useLocation();

  const sidebarItems = {
    admin: [
      {
        title: "Dashboard",
        icon: "mdi mdi-view-dashboard",
        link: "/dashboard",
      },
      { title: "Email", icon: "mdi mdi-email", link: "/email" },
      { title: "Users", icon: "mdi mdi-worker", link: "/users" },
      { title: "Profile", icon: "mdi mdi-face", link: "/my-profile" },
    ],
    employee: [
      { title: "Email", icon: "mdi mdi-email", link: "/email" },
      { title: "Profile", icon: "mdi mdi-face", link: "/my-profile" },
    ],
  };

  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
        <Link className="sidebar-brand brand-logo" to="/dashboard">
          <h4 className="mb-0">Email Sender</h4>
        </Link>
      </div>
      <ul className="nav">
        {isAuthenticated && (
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <img
                  className="img-xs rounded-circle"
                  src="/assets/images/faces/user.png"
                  alt=""
                />
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal">
                    {profileData.name}
                  </h5>
                  <span>{profileData.email}</span>
                </div>
              </div>
            </div>
          </li>
        )}
        {sidebarItems[role]?.map((item) => (
          <li
            className={`nav-item menu-items ${
              location.pathname === item.link ? "active" : ""
            }`}
            key={item.title}
          >
            <Link className="nav-link" to={item.link}>
              <span className="menu-icon">
                <i className={item.icon}></i>
              </span>
              <span className="menu-title">{item.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Sidebar;
